import Progress from 'redux-progress';
import * as actions from 'modules/checkout/payment/duck/actions';

export default (state = Progress.none, action) => {
  switch (action.type) {
    case actions.FETCH_ELIGIBLE_AUTO_RENEWAL:
      return action.progress;
    default:
      return state;
  }
};
